import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Check, Close, Recycling } from '@mui/icons-material';
import { RECYCLING_COLOR } from 'constants/colors';
import { CATEGORY_FAILED, FAILED_MILESTONE, isRecyclingEvent, progressByStatus } from 'constants/shipmentStatus';

export const MODE = {
  FILL: 'fill',
  OUTLINED: 'outlined',
};

const ICON_MAP = [
  {
    match: isRecyclingEvent,
    icon: Recycling,
    fontSize: 'small',
    mode: MODE.OUTLINED,
    color: RECYCLING_COLOR,
  },
  {
    match: (event) => event?.category === CATEGORY_FAILED || FAILED_MILESTONE.includes(event?.milestone),
    icon: Close,
    fontSize: 'small',
    mode: MODE.FILL,
  },
  {
    match: () => true, // every other event
    icon: Check,
    fontSize: 'medium',
    mode: MODE.FILL,
  },
];


const milestoneColor = (theme, event) => progressByStatus(theme)[event?.milestone]?.backgroundColor;

function EventTimelineIcon({ event, mode, color }) {
  const theme = useTheme();
  const white = theme.colors.common11;
  const matchingIcon = ICON_MAP.find((item) => item.match(event));
  const { icon: Icon } = matchingIcon;

  // prop mode is highest priority > matchingIcon mode > default to fill
  const resolvedMode = mode || matchingIcon?.mode || MODE.FILL;
  // prop color is highest priority > matchingIcon color > milestone color > default to common7
  const resolvedColor = color || matchingIcon?.color || milestoneColor(theme, event) || theme.colors.common7;
  
  const boxStyle =
    resolvedMode === MODE.OUTLINED
      ? { backgroundColor: white, color: resolvedColor, border: `1.5px solid ${resolvedColor}` }
      : { backgroundColor: resolvedColor, color: white }; // SvgIcon fills with currentColor

  return (
    <Box
      sx={{
        width: '30px',
        height: '30px',
        boxSizing: 'border-box',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 1,
        ...boxStyle,
      }}
      data-testid="event-status-indicator"
    >
      <Icon fontSize={matchingIcon?.fontSize} />
    </Box>
  );
}

export default EventTimelineIcon;
